import type { ExportColumnDef } from '../use/types/excel-export.types';

export async function exportToExcel<T>(
  data: T[],
  columns: ExportColumnDef<T>[],
  options: { sheetName: string; fileName: string }
): Promise<void> {
  if (!data || data.length === 0) {
    throw new Error('Nenhum dado para exportar');
  }

  const { default: ExcelJS } = await import('exceljs');

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet(options.sheetName);

  worksheet.columns = columns.map((col) => ({
    header: col.header,
    key: col.header,
    width: col.width,
    ...(col.wrapText
      ? { style: { alignment: { wrapText: true, vertical: 'top' as const } } }
      : {}),
  }));

  data.forEach((item) => {
    const row = Object.fromEntries(columns.map((col) => [col.header, col.getValue(item)]));
    worksheet.addRow(row);
  });

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = options.fileName;
  link.click();
  URL.revokeObjectURL(url);
}
